import { Clinic } from "src/app/models/database/clinic"
import { Employee } from "src/app/models/database/employee"

export class SetEmployee {
    static readonly type = '[Employee] Set'

    constructor(public payload: Employee) { }
}

export class SetOccupation {
    static readonly type = '[Employee] Occupation'

    constructor(public payload: string) { }
}

export class SetClinic {

    static readonly type = '[Clinic] Set'

    constructor(public payload: Clinic) { }
}

export class SetClinicToken {

    static readonly type = '[Token] Set'

    constructor(public payload: string) { }
}

export class LogOut {

    static readonly type = '[Employee] LogOut'

    constructor() { }
}